import React from 'react'
import { flexRender } from '@tanstack/react-table'

// flexRender mounts a function header/cell as its own component type, so
// column defs recreated on every render (inline `columns` arrays) remount
// every cell on each state change. Rendering through one stable component
// keeps cells mounted, which also avoids DOM errors when a mobile browser
// has translated (rewritten) the cell text nodes.
const FlexCell = ({ renderer, context }) => renderer(context)

const stableFlexRender = (renderer, context) => {
    if (
        typeof renderer === 'function' &&
        !renderer.prototype?.isReactComponent
    ) {
        return <FlexCell renderer={renderer} context={context} />
    }
    return flexRender(renderer, context)
}

export default stableFlexRender
